import React from 'react';
import { TableContainer } from '../../common/Container';
import TabMenu from '../TabMenu';
import styled from 'styled-components';
import radioChecked from '../../../resources/images/common/done1.png';
import radioUnchecked from '../../../resources/images/common/done2.png';

const MenuItem = styled.div`
  padding: 14px 28px;
  font-size: 16px;
  color: ${props => (props.selected ? '#1A73E9' : '#000')};
  font-weight: ${props => (props.selected ? 'bold' : 'normal')};
  cursor: pointer;
  transition: background 0.1s;
`;

const SubTitle = styled.div`
  padding: 0 10px;
  font-size: 16px;
  color: '#000';
  border-left: 6px solid #1A73E9;
  margin: 10px; 10px;
`;

const PageTitle = styled.div`
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 16px;
  margin: 28px 0 23px;
  h1 { font-size: 23px; font-weight: 700; margin: 0; color: #141414; }
  p { font-size: 13px; margin: 0; color: #868e96; }
`;

const FlexRow = styled.div`
  display: flex;
  gap: 24px;
  align-items: flex-start;
`;

const SideMenu = styled.div`
  width: 160px;
  flex-shrink: 0;
`;

const SideBorder = styled.div`
  border: 1px solid #e6e9ee;
  border-radius: 5px;
  min-height: 330px;
  padding: 20px 0;
`;

const MenuTitle = styled.div`
  font-size: 16px;
  font-weight: 400;
  color: #000;
  margin-bottom: 8px;
`;

const MainPanel = styled.div`
  flex: 1;
  min-width: 0;
`;
const MainBorder = styled.div`
  border: 1px solid #e6e9ee;
  border-radius: 5px;
  min-height: 330px;
  padding: 25px;
`;
const RadioGroup = styled.div`
  display: flex;
  gap: ${props => props.gap ? props.gap : '32px'};
  margin-bottom: 30px;
  margin-left: 20px;
`;

const FakeRadio = styled.img`
  width: 22px;
  height: 22px;
  margin-right: 9px;
  vertical-align: middle;
  user-select: none;
`;

const RadioLabel = styled.label`
  display: flex;
  align-items: center;
  font-size: 16px;
  gap: 7px;
  font-weight: 500;
  cursor: pointer;
`;

const SubRadioGroup = styled(RadioGroup)`
    padding-top: 20px;
`;

const CheckList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 9px;
  margin-bottom: 48px;
`;

const CheckLabel = styled.label`
  display: flex;
  align-items: center;
  font-size: 16px;
  gap: 8px;
  padding: 7px 0;
  user-select: none;
`;

const Checkbox = styled.input.attrs({ type: 'checkbox' })`
  accent-color: #247fff;
`;

const Footer = styled.div`
  padding-top: 20px;
  display: flex;
  justify-content: flex-end;
  gap: 16px;
`;


const CommitButton = styled.button`
  background-color: ${props => props.background ? props.background : '#247fff'};
  color: ${props => props.color ? props.color : '#fff'};
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  width: 100px;
  height: 40px;
  font-size: 16px;
  font-weight: 500;
`;

const DoorConfig = ({
    schedule,
    doorList,
    selectedDoor,
    setSelectedDoor,
    itemList,
    setCondition,
    setMembershipType,
    setMembershipList,
    onSaveDoor,
    onCancelDoor,
}) => {
    console.log("doorList : ", doorList);
    console.log("itemList : ", itemList);

    const _itemList = itemList? itemList.sort((a, b) => a.name.localeCompare(b.name)) : []
  
    // 체크박스 토글 핸들러
    const toggleType = (ClubItemID) => {
        if(!selectedDoor) return;
        const isSelected = selectedDoor.membershipList.includes(ClubItemID)
        if(isSelected) {
            setMembershipList(selectedDoor.id, selectedDoor.membershipList.filter((v) => v !== ClubItemID))
        } else {
            setMembershipList(selectedDoor.id, [...selectedDoor.membershipList, ClubItemID])
        }
    };
  return (
    <>
      <TabMenu underbar />
      <TableContainer>
        <PageTitle><h1>출입문 설정</h1><p>출입 조건과 출입 시간을 관리합니다.</p></PageTitle>
        <FlexRow>
            <SideMenu>
                <MenuTitle>개별 출입문 설정</MenuTitle>
                <SideBorder>
                    {doorList.map((item, idx) => (
                        <MenuItem
                        key={`doorList_${idx}`}
                        selected={selectedDoor && selectedDoor.id === item.id}
                        onClick={() => setSelectedDoor(item)}
                        >
                        {item.name}
                        </MenuItem>
                    ))}
                </SideBorder>
            </SideMenu>
            <MainPanel>
                <MenuTitle>{selectedDoor && selectedDoor.name} 설정</MenuTitle>
                <MainBorder>
                    <SubTitle>출입 가능한 성별 선택</SubTitle>
                    <SubRadioGroup>
                        <RadioLabel
                            onClick={() => setCondition(selectedDoor.id, 1)}
                        >
                            <FakeRadio
                                src={selectedDoor && selectedDoor.condition === 1 ? radioChecked : radioUnchecked}
                                alt={selectedDoor && selectedDoor.condition === 1 ? "checked" : "unchecked"}
                            />
                            남녀 모두 출입 가능
                        </RadioLabel>
                        <RadioLabel
                            onClick={() => setCondition(selectedDoor.id, 2)}
                        >
                            <FakeRadio
                                src={selectedDoor && selectedDoor.condition === 2 ? radioChecked : radioUnchecked}
                                alt={selectedDoor && selectedDoor.condition === 2 ? "checked" : "unchecked"}
                            />
                            남자만 출입 가능
                        </RadioLabel>
                        <RadioLabel
                            onClick={() => setCondition(selectedDoor.id, 3)}
                        >
                            <FakeRadio
                                src={selectedDoor && selectedDoor.condition === 3 ? radioChecked : radioUnchecked}
                                alt={selectedDoor && selectedDoor.condition === 3 ? "checked" : "unchecked"}
                            />
                            여자만 출입 가능
                        </RadioLabel>
                    </SubRadioGroup>

                    <SubTitle>출입 가능한 회원권 선택</SubTitle>
                    <RadioGroup>
                        <RadioLabel
                            onClick={() => setMembershipType(selectedDoor.id, 0)}
                        >
                            <FakeRadio
                                src={selectedDoor && selectedDoor.membershipType === 0 ? radioChecked : radioUnchecked}
                                alt={selectedDoor && selectedDoor.membershipType === 0 ? "checked" : "unchecked"}
                            />
                            <div style={{display: 'flex', flexDirection: 'column', paddingTop: '20px'}}>
                                <div>모든 회원권 출입 가능</div>
                                <div style={{fontSize: '14px', color: '#646464', paddingTop: '5px'}}>회원권의 종류와 상관없이 출입이 가능합니다.</div>
                            </div>
                        </RadioLabel>
                        <RadioLabel
                            onClick={() => setMembershipType(selectedDoor.id, 1)}
                        >
                            <FakeRadio
                                src={selectedDoor && selectedDoor.membershipType === 1 ? radioChecked : radioUnchecked}
                                alt={selectedDoor && selectedDoor.membershipType === 1 ? "checked" : "unchecked"}
                            />
                            <div style={{display: 'flex', flexDirection: 'column', paddingTop: '20px'}}>
                                <div>선택한 회원권만 출입 가능</div>
                                <div style={{fontSize: '14px', color: '#646464', paddingTop: '5px'}}>특정한 회원권 소지자만 출입 가능하도록 제한합니다.</div>
                            </div>
                            
                        </RadioLabel>
                    </RadioGroup>
                    {
                        selectedDoor && selectedDoor.membershipType === 1 ?
                        <CheckList>
                            {_itemList.map((item) => (
                                item.isDelete == 1 ? null :
                                <CheckLabel key={`itemList_${item.ClubItemID}`}>
                                    <Checkbox
                                    checked={selectedDoor.membershipList.includes(item.ClubItemID)}
                                    onChange={() => toggleType(item.ClubItemID)}
                                    />
                                    {item.name}
                                </CheckLabel>
                            ))}
                        </CheckList>
                        :null
                    }
                    <div style={{fontSize: '1rem', lineHeight: '1.3', color: '#FF0000', paddingTop: '30px'}}>
                        출입문 설정을 변경하실 경우, 해당 설정은 기존에 판매된 회원권에는 자동으로 적용되지 않으며, 변경 이후 새로 판매되는 회원권에만 적용됩니다. 따라서 출입문 설정 변경 시에는 신중하게 검토하신 후 진행해주시기 바랍니다. 
                    </div>
                    <div style={{fontSize: '0.95rem', color: '#A0A0A0', paddingTop: '15px'}}>
                        만약 변경된 출입문 설정을 기존 회원권에도 반영하시려면, 해당 회원권을 보유한 회원을 일일이 찾아 수동으로 수정하셔야 합니다.
                    </div>
                </MainBorder>
                <Footer>
                    <CommitButton background="#1A73E9" color="#fff" onClick={onSaveDoor}>저장</CommitButton>
                    <CommitButton background="#A4A4A4" color="#000" onClick={onCancelDoor}>취소</CommitButton>
                </Footer>
            </MainPanel>
        </FlexRow>
        {schedule}
      </TableContainer>
    </>
  );
};

export default DoorConfig;
